import { render, staticRenderFns } from "./newsSukan.vue?vue&type=template&id=62a01255&scoped=true&"
import script from "./newsSukan.vue?vue&type=script&lang=js&"
export * from "./newsSukan.vue?vue&type=script&lang=js&"
import style0 from "./newsSukan.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsSukan.vue?vue&type=style&index=1&id=62a01255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a01255",
  null
  
)

export default component.exports